// extracted by mini-css-extract-plugin
export default {"wrapper":"sp","form":"tp","option":"up","checkbox":"vp","success":"wp"};